/*
 * @Author: yongsheng.zhang 
 * @Date: 2017-10-19 17:05:33 
 * @Last Modified by: yongsheng.zhang
 * @Last Modified time: 2017-11-06 10:33:00
 */

/**
 * 首页图片轮播
 * @param {string} domD 图片轮播的框架节点 必选参数
 * @param {string} domF 图片轮播的父节点 必选参数
 * @param {string} domC 图片轮播的图片节点 必选参数
 * @param {number} time 轮播的时间间隔 可选参数
 * @param {boolean} position 轮播图片的方向，false由下往上，true由左往右 两个可选参数
 */
const $ = require('jquery')
const sliderPicture = require('../../../lib/slider.js')
const LXBid = require('../../../lib/lx-bid.js')
const LXWrap = require('../../../lib/lx.js')

const picSwipe = (domD, domF, domC, position = false, time = 4000) => {
    if (!domD || !domC || !domF) {
        console.log('没有传入图片节点参数')
        return
    }
    // 轮播图点击打点
    LXWrap($('.pic-target'), LXBid.bannerClickBid, false, false)
    let $picItem = $(domD).find(domC)
    if ($picItem.length <= 1) return
    sliderPicture('#pic-nav', {
        type: 'slide',
        autoplay: time
    });
    // let $picNav = $(domD);
    let $picCon = $(domD).find(domF)
    if (position)$picCon.addClass('nav-right')
    // let $picItem = $(domD).find(domC);
    // // 小于2张图片时，不轮播
    // if ($picItem.length <= 1) return;
    // // 大于2张图片
    // let _pointDom = '<div class="nav-point-con"><ul class="nav-point">';
    // let picItemArray = new Array($picItem.length);
    // // 循环生成图片DOM
    // for (let index of picItemArray.keys()) {
    //     _pointDom += `<li class="point ${index === 0 ? 'current' : ''}" data-index="${index}"></li>`;
    // }
    // _pointDom = _pointDom + '</ul></div>';
    // $picNav.append(_pointDom);
    // // 轮播
    // let swipeLength = 0;
    // let positionLength = 0;// 轮播长度
    // let swipeIndex = 0;
    // let pointIndex;// 轮播数量，鼠标指向的数字下标。
    // let swipePosition = position ? 'left' : 'top';// 轮播反向
    // let suspend = false;// 当鼠标移动到下标时，暂停计时器

    // positionLength = position ? $picItem.width() : $picItem.height();
    // const swipeFun = () => {
    //     if (suspend) return;
    //     swipeLength = positionLength * (swipeIndex + 1);
    //     if (swipeIndex >= $picItem.length - 1) {
    //         $picCon.css(swipePosition, 0);
    //         $picNav.find('.point').removeClass('current').eq(0).addClass('current')
    //         swipeIndex = 0;
    //     } else {
    //         $picCon.css(swipePosition, -swipeLength);
    //         $picNav.find('.point').removeClass('current').eq(swipeIndex + 1).addClass('current');
    //         swipeIndex++;
    //     }
    // }
    // setInterval(swipeFun, time);
    // $picNav.find('.point').on('mouseover', function() {
    //     // 鼠标指向，则滚动到当前的图片，移开时，从当前开始轮播
    //     suspend = true;
    //     $picNav.find('.point').removeClass('current');
    //     $(this).addClass('current');
    //     pointIndex = parseInt($(this).attr('data-index'));
    //     if (pointIndex === swipeIndex) return;
    //     $picCon.css(swipePosition, -(positionLength * (pointIndex)));
    //     swipeIndex = pointIndex;
    // });
    // $picNav.find('.point').on('mouseout', function() {
    //     suspend = false;
    // });
}
module.exports = picSwipe;



// WEBPACK FOOTER //
// ./src/pages/index/component/pic-nav.js